import { WebinarStreamingInfo } from 'src/core/types';
import axios from './axios';
import { useQuery } from 'react-query';

export interface useWebinarStreamingInfoProps {
  id?: string;
}

export function useWebinarStreamingInfo(props: useWebinarStreamingInfoProps) {
  const { id } = props;

  return useQuery<WebinarStreamingInfo>(
    ['webinar-streaming-info', id],
    async () => {
      return axios
        .get<WebinarStreamingInfo>(`/posht/yashar/webinars-info/${id}/`)
        .then((res) => res.data);
    },
    {
      suspense: false,
    },
  );
}
